webpackJsonp([32548347793320],{

/***/ 56:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(66);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactstrap = __webpack_require__(17);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _EventsModule = __webpack_require__(65);
	
	var _EventsModule2 = _interopRequireDefault(_EventsModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Events = function Events(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _EventsModule2.default.jumbo },
	    _react2.default.createElement(
	      'div',
	      { className: 'h-100 w-100 ' + _EventsModule2.default.content },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            {
	              md: { size: 6, offset: 3 },
	              sm: { size: 8, offset: 2 },
	              className: 'text-center'
	            },
	            _react2.default.createElement(
	              'h2',
	              { className: 'text-light' },
	              'Events & Functions'
	            ),
	            _react2.default.createElement('hr', { className: 'bg-light' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light' },
	              'We offer multiple private areas for events & functions.'
	            ),
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/contact' },
	              _react2.default.createElement(
	                _reactstrap.Button,
	                { outline: true, color: 'primary' },
	                'Book An Event'
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: data.childImageSharp.sizes,
	      style: {
	        width: "100%",
	        height: "100%"
	      }
	    })
	  );
	};
	
	exports.default = Events;
	module.exports = exports['default'];

/***/ }),

/***/ 65:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"jumbo":"src-components----Events-module---jumbo---lKice","content":"src-components----Events-module---content---19dyn"};

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(17);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _HeaderModule = __webpack_require__(402);
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// ToDo: Vertically center Jumbotron
	var Header = function Header(_ref) {
	  var data = _ref.data;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _HeaderModule2.default.jumbo },
	    _react2.default.createElement(
	      'div',
	      { className: 'h-100 w-100 ' + _HeaderModule2.default.content },
	      _react2.default.createElement(
	        _reactstrap.Container,
	        null,
	        _react2.default.createElement(
	          _reactstrap.Row,
	          null,
	          _react2.default.createElement(
	            _reactstrap.Col,
	            {
	              md: { size: 6, offset: 3 },
	              sm: { size: 8, offset: 2 },
	              className: 'text-center'
	            },
	            _react2.default.createElement(
	              'h1',
	              { className: 'text-light' },
	              'Food Menu'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light lead' },
	              'This is the food menu'
	            ),
	            _react2.default.createElement('hr', { className: 'bg-light' }),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-light' },
	              'Made from locally sourced...'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_gatsbyImage2.default, {
	      sizes: data.childImageSharp.sizes,
	      style: {
	        height: "100%"
	      }
	    })
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 402:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"jumbo":"src-components-food----Header-module---jumbo---zLp0F","content":"src-components-food----Header-module---content---1eH_r"};

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(22);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _reactstrap = __webpack_require__(17);
	
	var _MenuModule = __webpack_require__(403);
	
	var _MenuModule2 = _interopRequireDefault(_MenuModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Menu = function Menu(_ref) {
	  var starters = _ref.starters,
	      mains = _ref.mains,
	      desserts = _ref.desserts;
	
	  return _react2.default.createElement(
	    _reactstrap.Container,
	    { className: 'text-center' },
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: 'my-5' },
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6, className: 'mb-5' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Starters'
	        ),
	        _react2.default.createElement('hr', { className: 'bg-primary w-75' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Homemade soup of the day with bread - \xA35.99'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Spicy chicken wings with cheese dip - \xA35.49'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Battered prawns, sweet chilli sauce - \xA36.95'
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6 },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          outerWrapperClassName: 'h-100',
	          sizes: starters.childImageSharp.sizes,
	          style: {
	            height: "100%"
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: 'mb-5' },
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6, className: _MenuModule2.default.itemone + ' mb-5' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Mains'
	        ),
	        _react2.default.createElement('hr', { className: 'bg-primary w-75' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Roast Sirloin of beef, roast potatoes & seasonal vegetables - \xA314.99'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Roast Chicken supreme, roast potatoes & seasonal veg - \xA312.99'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Cheese burger, lettuce, tomato, bacon & chunky chips - \xA313.99'
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6, className: _MenuModule2.default.itemtwo },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          outerWrapperClassName: 'h-100',
	          sizes: mains.childImageSharp.sizes,
	          style: {
	            height: "100%"
	          }
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactstrap.Row,
	      { className: 'mb-5' },
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6, className: 'mb-5' },
	        _react2.default.createElement(
	          'h2',
	          null,
	          'Desserts'
	        ),
	        _react2.default.createElement('hr', { className: 'bg-primary w-75' }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Black Forest Gateau & cream - \xA36.99'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Chocolate & coconut torte - \xA35.99'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Sticky toffee pudding & vanilla ice cream - \xA36.49'
	        )
	      ),
	      _react2.default.createElement(
	        _reactstrap.Col,
	        { md: 6 },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          outerWrapperClassName: 'h-100',
	          sizes: desserts.childImageSharp.sizes,
	          style: {
	            height: "100%"
	          }
	        })
	      )
	    )
	  );
	};
	
	exports.default = Menu;
	module.exports = exports['default'];

/***/ }),

/***/ 403:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"itemone":"src-components-food----Menu-module---itemone---2CrNZ","itemtwo":"src-components-food----Menu-module---itemtwo---3cqSk"};

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Header = __webpack_require__(292);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Menu = __webpack_require__(293);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Events = __webpack_require__(56);
	
	var _Events2 = _interopRequireDefault(_Events);
	
	var _ContactAndMap = __webpack_require__(76);
	
	var _ContactAndMap2 = _interopRequireDefault(_ContactAndMap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Food = function Food(_ref) {
	  var data = _ref.data;
	  var foodImage = data.foodImage,
	      starters = data.starters,
	      mains = data.mains,
	      desserts = data.desserts,
	      eventsImage = data.eventsImage;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'top', style: { marginTop: '63px' } },
	    _react2.default.createElement(_Header2.default, { data: foodImage }),
	    _react2.default.createElement(_Menu2.default, {
	      starters: starters,
	      mains: mains,
	      desserts: desserts
	    }),
	    _react2.default.createElement(_Events2.default, { data: eventsImage }),
	    _react2.default.createElement(_ContactAndMap2.default, null)
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Food;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-food-js-87bfcc7a9d6c349092c6.js